import confetti from 'canvas-confetti';

let listenerRegistered = false;
let changeEventHandler = null;

/**
 * Trigger a confetti effect at the specified coordinates
 * @param {Object} options - Configuration options
 * @param {number} options.x - Horizontal position (0-1)
 * @param {number} options.y - Vertical position (0-1)
 */
export function triggerConfetti({ x = 0.5, y = 0.5 }) {
  confetti({
    particleCount: 50, // Reduced particle count for better performance
    spread: 60, // Slightly reduced spread
    origin: { x, y },
    colors: ['#1867C0', '#5CBBF6', '#41B883', '#E91E63', '#FF9800', '#9C27B0'],
    disableForReducedMotion: true, // Accessibility improvement
    gravity: 1.2, // Slightly increased gravity for faster animation
    scalar: 0.8, // Slightly smaller particles
    zIndex: 9999, // Ensure confetti appears above other elements
  });
}

/**
 * Initialize confetti event listeners for checkboxes
 * @param {Object} store - Vuex store to access user settings
 * @returns {Function} Cleanup function to remove the event listener
 */
export function initConfettiListeners(store) {
  if (typeof document === 'undefined' || listenerRegistered) return;

  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const debouncedTriggerConfetti = debounce(triggerConfetti, 100);

  changeEventHandler = (event) => {
    const user = store.state.auth.user;
    if (!user?.settings?.letsParty) return;

    if (event.target.type === 'checkbox' && event.target.checked) {
      const rect = event.target.getBoundingClientRect();
      const x = (rect.left + rect.width / 2) / window.innerWidth;
      const y = (rect.top + rect.height / 2) / window.innerHeight;
      debouncedTriggerConfetti({ x, y });
    }
  };

  document.addEventListener('change', changeEventHandler);
  listenerRegistered = true;

  return function cleanup() {
    if (changeEventHandler) {
      document.removeEventListener('change', changeEventHandler);
      listenerRegistered = false;
      changeEventHandler = null;
    }
  };
}
